enum COMPATIBLE_BROWSERS {
    ios, 
    safari, 
    chrome, 
    crios, 
    samsung
}
export default COMPATIBLE_BROWSERS;